/* El tramo de los eventos que nacen en Supabase (el hub y el bot): desde
 * 50.000.000, con el prefijo y los ocho dígitos de siempre (`005-50000192`).
 * El porqué está en `eventFunctions.js` («EL NÚMERO DE LOS EVENTOS QUE NACEN
 * ACÁ»).
 *
 * Va en un módulo aparte porque lo usan `eventFunctions.js` (para numerar) y
 * `services/cols/eventos.service.js` (para listar), y el primero importa al
 * segundo. El mismo número vive en el bot (`eventos_numero.RANGO`) y en el
 * sync (`TRAMO_PROPIO`, scripts/sync-cantapp/config.mjs). */
export const RANGO_SUPABASE = 50000000;
